import { GraphTraversalResult, LoadedGraphWithViewpointMode } from '../types';
import { GraphModelShape } from '@ardoq/data-model';
import { createReferenceIdFromParentAndChildId } from '../utils/grouping/parentChildUtils';

type GetComponentAndReferenceIdsForViewpointModeArgs = {
  loadedGraph: LoadedGraphWithViewpointMode;
  graph: GraphModelShape;
};
export const getTraversalResultForViewpointMode = ({
  loadedGraph,
  graph,
}: GetComponentAndReferenceIdsForViewpointModeArgs): GraphTraversalResult => {
  const parentReferenceIds = new Set(
    loadedGraph.parentChildReferences.map(
      ({ source: parentId, target: childId }) =>
        createReferenceIdFromParentAndChildId(parentId, childId)
    )
  );

  const { scopeComponentIds, scopeData } = loadedGraph;
  const scopeComponentIdsSet = new Set(scopeComponentIds);
  /* A `virtual` reference is a parent-child relationship rather than a lateral one, and the graph
     model carries it under its own id beside the lateral references — `enhance` puts it in
     `referenceMap` whenever the payload lists its id in `graphReferenceIds`. Taken as lateral it
     reaches `getPureGraphEdge` without `isParentChildReference`, where the reference-type lookup
     returns null for anything virtual and the edge is dropped. The hierarchy it stands for is
     already keyed off `parentChildReferences` above; `buildGraphForDiscover` separates the two the
     same way. */
  const filteredReferenceIds = Array.from(graph.referenceMap)
    .filter(
      ([id, { sourceId, targetId }]) =>
        !scopeData.referencesById[id]?.virtual &&
        scopeComponentIdsSet.has(sourceId) &&
        scopeComponentIdsSet.has(targetId)
    )
    .map(([id]) => id);

  const traversedReferenceIds = [
    ...filteredReferenceIds,
    ...parentReferenceIds,
  ];

  return {
    componentIds: scopeComponentIds,
    traversedReferenceIds,
    parentReferenceIds,
  };
};
